export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./messengers.vue?vue&type=template&id=4316f5a4&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/messengers.vue?vue&type=template&id=4316f5a4&scoped=true
// module id = fHCG
// module chunks = 0